import './PaymentEntryAdd.scss';
import {
  App,
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Dropdown,
  Flex,
  Form,
  Input,
  Row,
  Select,
  Space,
  Spin,
} from 'antd';
import React, { useEffect, useState } from 'react';
import Heading from '../../common/Heading/Heading';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  addPaymentEntry,
  cancelPaymentEntry,
  getAccounts,
  getCustomerSalesInvoices,
  getModeOfPayments,
  getMopAccountMode,
  getParties,
  getPaymentEntryDetails,
  getPaymentEntryDetailsName,
  getPaymentReferences,
  submitDoc,
  updatePaymentEntry,
} from '../../../network/PaymentEntry';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useNavigate, useParams } from 'react-router-dom';
import { MdDelete } from 'react-icons/md';
import { DownOutlined, PlusOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { getSalesInvoiceDetails } from '../../../network/salesInvoice';
import { getCostCenters } from '../../../network/costCenter';
import DeductionsListPayment from './DeductionsListPayment';
import PaymentReferencesList from './PaymentReferencesList';
import { ModalAddBankTransfer } from '../ModalApp/ModalApp';
import { getPaymentDetails } from '../../../network/employeeAdvance';
import { getSalesOrderDetailsPaymentEntry } from '../../../network/salesOrder';
import {
  getSearchApiAcount,
  getSearchApiSearchText,
} from '../../../network/itemList';
import HeadingApp from '../../../hooks/HeadingApp';
import { FaMoneyBillWave } from 'react-icons/fa';

const PaymentEntryAdd = ({
  t,
  edit,
  sales,
  invoice,
  receipt,
  employee,
  salesOrder,
}) => {
  const { id, idPurchaseInvoice, idEmployeeAdvance, idSalesOrder } =
    useParams();
  const [form] = Form.useForm();
  const [submitButton, setSubmitButton] = useState(false);
  const [openBankTransfer, setOpenBankTransfer] = useState(false);
  const [searchTxt, setSearchTxt] = useState('');
  const [dataSourcePayment, setDataSourcePayment] = useState([{}]);
  const [dataSourceReference, setDataSourceReference] = useState([{}]);
  const [selectName, setSelectName] = useState('');
  const customer = Form.useWatch('party_type', form);
  const watchPartyId = Form.useWatch('party', form);
  const watchPaymentType = Form.useWatch('payment_type', form);
  const selectReference = Form.useWatch('select_reference', form);
  const client = useQueryClient();
  const navigate = useNavigate();
  const [loadingParties, setLoadingParties] = useState(false);
  const [dataStatus, setDataStatus] = useState(null);
  const [loadingAdd, setLoadingAdd] = useState(false);
  const [valueReferenceType, setValueReferenceType] = useState('');
  const [searchTxtAccount, setSearchTxtAccount] = useState('');
  const { message } = App.useApp();

  const { mutate: onAddPaymentEntryForm } = useMutation({
    mutationKey: ['addPaymentEntryForm'],
    mutationFn: (data) =>
      edit ? updatePaymentEntry(data, id) : addPaymentEntry(data),
    onSuccess: (data) => {
      setLoadingAdd(false);
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(edit ? 'Updated successfully' : 'Added successfully');
      setSelectName(edit ? id : data?.data?.name);
      setSubmitButton(true);
      // edit && dataStatus !== 0 && invoice
      //   ? navigate('/payment-voucher')
      //   : navigate('/receipt-voucher');

      // form.resetFields();
      client.invalidateQueries({
        queryKey: [queryKeys.getPaymentEntries],
      });
      if (edit && dataStatus !== 0) {
        if (!invoice) {
          navigate('/receipt-voucher');
        } else {
          navigate('/payment-voucher');
        }
      }
    },
    onError: (error) => {
      setLoadingAdd(false);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
    },
  });
  const { mutate: onSubmitPaymentEntry } = useMutation({
    mutationKey: ['submitDoc'],
    mutationFn: (name) => submitDoc(name),
    onSuccess: (data) => {
      console.log(data, 'datasubmitDoc');

      setLoadingAdd(false);
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      data?.message?.message && message.success(data?.message?.message);
      client.invalidateQueries({
        queryKey: [queryKeys.getPaymentEntries, id],
      });
      // invoice ? navigate('/payment-voucher') : navigate('/receipt-voucher');
      if (submitButton) {
        if (!invoice) {
          navigate('/receipt-voucher');
        } else {
          navigate('/payment-voucher');
        }
      }
    },
    onError: (error) => {
      setLoadingAdd(false);
      console.log(error, 'error');
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
      // message.error(error);
    },
  });
  // const { data: modeOfPayments } = useQuery({
  //   queryKey: [queryKeys.getModeOfPayments],
  //   queryFn: () => getModeOfPayments(),
  //   keepPreviousData: true,
  //   select: (data) => data?.message?.mode_of_payments,
  // });
  const { data: modeOfPayments } = useQuery({
    queryKey: [queryKeys.getModeOfPayments, searchTxt],
    queryFn: () =>
      getSearchApiSearchText({
        type: 'Mode of Payment',
        searchTxt: searchTxt,
      }),
    keepPreviousData: true,
  });
  const accountFilter = '{"is_group":0}';
  const { data: parties } = useQuery({
    queryKey: [queryKeys.getAccounts, searchTxtAccount],
    // queryFn: () => getAccounts(accountFilter),
    queryFn: () =>
      getSearchApiAcount({ type: 'Account', searchTxt: searchTxtAccount }),
    keepPreviousData: true,
    // select: (data) => data?.message?.accounts,
    select: (data) => data?.message,
  });
  console.log(parties, 'parties');
  const { data: costCenters } = useQuery({
    queryKey: [queryKeys.getCostCenters],
    queryFn: () => getCostCenters(),
    keepPreviousData: true,
  });
  const { data: salesInvoice, isLoading: loadingSales } = useQuery({
    queryKey: [queryKeys.getPaymentEntryDetailsName, id],
    queryFn: () => getPaymentEntryDetailsName('Sales Invoice', id),
    enabled: !!sales,
  });
  const { data: salesOrderDetails, isLoading: loadingSalesOrder } = useQuery({
    queryKey: [queryKeys.getPaymentEntryDetailsName, idSalesOrder],
    queryFn: () => getSalesOrderDetailsPaymentEntry(idSalesOrder),
    enabled: !!salesOrder,
  });
  const { data: employeeAdvance, isLoading: loadingEmployeeAdvance } = useQuery(
    {
      queryKey: [queryKeys.getPaymentEntryDetailsEmployee, idEmployeeAdvance],
      queryFn: () => getPaymentDetails(idEmployeeAdvance),
      enabled: !!employee,
    }
  );
  const { data: purchaseInvoice, isLoading: loadingInvoice } = useQuery({
    queryKey: [queryKeys.getPaymentEntryDetailsName, idPurchaseInvoice],
    queryFn: () =>
      getPaymentEntryDetailsName('Purchase Invoice', idPurchaseInvoice),
    enabled: !!invoice,
  });
  const { data: paymentEntry, isLoading: loadingPayment } = useQuery({
    queryKey: [queryKeys.getPaymentEntryDetails, id],
    queryFn: () => getPaymentEntryDetails(id),
    enabled: !!edit,
  });
  // const { data: paymentReferencesName, isLoading: loadingPaymentReference } = useQuery({
  //   queryKey: [queryKeys.getPaymentReferences,watchPartyId, valueReferenceType],
  //   queryFn: () => getPaymentReferences(watchPartyId,valueReferenceType),
  //   enabled: !!valueReferenceType && !!watchPartyId,
  // });
  const { mutate: onAddPaymentEntry, data: partiesData } = useMutation({
    mutationKey: [queryKeys.getParties],
    mutationFn: (id) => getParties(id),
    onSuccess: () => {
      setLoadingParties(false);
    },
    onError: () => {
      setLoadingParties(false);
    },
  });
  const { mutate: onGetMopAccountMode, data: mopAccountMode } = useMutation({
    mutationKey: [queryKeys.getMopAccountMode],
    mutationFn: (id) => getMopAccountMode(id),
    onSuccess: (res) => {
      console.log(res, 'res');
      setSearchTxtAccount(res?.message?.account);
      if (watchPaymentType === 'Pay') {
        form.setFieldsValue({ paid_from: res?.message?.account });
      } else {
        form.setFieldsValue({ paid_to: res?.message?.account });
      }
    },
    onError: () => {},
  });
  // console.log(mopAccountMode, 'mopAccountMode');

  // const { mutate: onGetPaymentReferences, data: paymentReferencesName } =
  //   useMutation({
  //     mutationKey: [queryKeys.getPaymentReferences],
  //     mutationFn: (id) => getPaymentReferences(watchPartyId,id),
  //   });
  const { mutate: onGetCustomer, data: customerInvoice } = useMutation({
    mutationKey: [queryKeys.getCustomerSalesInvoices],
    mutationFn: (customerName) => getCustomerSalesInvoices(customerName),
  });

  const handleCancelSalesInvoice = useMutation({
    mutationFn: (id) => cancelPaymentEntry(id),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      client.invalidateQueries({
        queryKey: [queryKeys.getPaymentEntryDetails, id],
      });
      message.success(data?.message?.message || 'Cancelled successfully');
    },
    onError: () => {
      setLoadingAdd(false);
      message.error('حدث خطأ ما');
    },
  });
  const onFinish = (values) => {
    // console.log('Success:', values);
    setLoadingAdd(true);
    onAddPaymentEntryForm({
      ...values,
      paid_amount: values?.paid_amount ? +values?.paid_amount : 0,
      received_amount: values?.paid_amount ? +values?.paid_amount : 0,
      cheque_date: dayjs(values?.cheque_date).format('YYYY-MM-DD'),
      posting_date: dayjs(values?.posting_date).format('YYYY-MM-DD'),
      // name:id || "",
      deductions: dataSourcePayment?.find((deduction) => !deduction?.amount)
        ? []
        : dataSourcePayment?.map((deduction) => {
            return {
              account: deduction?.account,
              cost_center: deduction?.cost_center,
              amount: Number(deduction?.amount),
            };
          }) || [],
      references: dataSourceReference?.map((reference) => {
        return {
          reference_doctype: reference?.reference_doctype,
          total_amount: reference?.total_amount,
          outstanding_amount: reference?.outstanding_amount,
          allocated_amount: +reference?.allocated_amount,
          reference_name: reference?.reference_name,
          due_date: dayjs(reference?.due_date).format('YYYY-MM-DD'),
        };
      }),
    });
  };
  // useEffect(() => {
  //   if (salesInvoice) {
  //     onGetPaymentReferences('Sales Invoice');
  //     // onGetCustomer(salesInvoice?.message?.customer);
  //     onAddPaymentEntry('Customer');
  //   } else if (edit && paymentEntry) {
  //     onAddPaymentEntry(paymentEntry?.data?.party_type);
  //     if (paymentEntry?.data?.party_type === 'Customer') {
  //       onGetCustomer(paymentEntry?.data?.party);
  //     }
  //   }
  // }, [id, salesInvoice, edit, paymentEntry]);

  useEffect(() => {
    if (employee && employeeAdvance) {
      console.log(employeeAdvance, 'salesInvoice');
      onAddPaymentEntry(employeeAdvance?.message?.party_type);
      // console.log(employeeAdvance?.message, 'salesInvoice?.message');
      setDataSourceReference(
        employeeAdvance?.message?.references?.length > 0
          ? employeeAdvance?.message?.references
          : [{}]
      );
      form.setFieldsValue({
        ...employeeAdvance?.message,
        select_reference: id,
        party_type: employeeAdvance?.message?.party_type,
        posting_date: dayjs(employeeAdvance?.message?.posting_date),
        payment_type: employeeAdvance?.message?.payment_type || 'Receive',
        deductions: [{}],
      });
    }
  }, [employeeAdvance]);
  useEffect(() => {
    if (salesInvoice) {
      console.log(salesInvoice, 'salesInvoice');
      onAddPaymentEntry('Customer');
      console.log(salesInvoice?.message, 'salesInvoice?.message');
      setDataSourceReference(
        salesInvoice?.message?.references?.length > 0
          ? salesInvoice?.message?.references
          : [{}]
      );
      form.setFieldsValue({
        ...salesInvoice?.message,
        select_reference: id,
        party_type: 'Customer' || salesInvoice?.message?.party_type,
        posting_date: dayjs(salesInvoice?.message?.posting_date),
        payment_type: salesInvoice?.message?.payment_type || 'Receive',
        deductions: [{}],
      });
    }
  }, [salesInvoice]);
  useEffect(() => {
    if (purchaseInvoice && invoice) {
      // console.log(purchaseInvoice, 'purchaseInvoice');
      onAddPaymentEntry(purchaseInvoice?.message?.party_type);
      console.log(purchaseInvoice?.message, 'purchaseInvoice?.message');
      setDataSourceReference(
        purchaseInvoice?.message?.references?.length > 0
          ? purchaseInvoice?.message?.references
          : [{}]
      );
      form.setFieldsValue({
        ...purchaseInvoice?.message,
        select_reference: id,
        party_type: purchaseInvoice?.message?.party_type,
        posting_date: dayjs(purchaseInvoice?.message?.posting_date),
        payment_type: purchaseInvoice?.message?.payment_type || 'Receive',
        deductions: purchaseInvoice?.message?.deductions || [{}],
      });
    }
  }, [purchaseInvoice, invoice]);
  useEffect(() => {
    if (paymentEntry && edit) {
      setDataStatus(paymentEntry?.data?.docstatus);
      onAddPaymentEntry(paymentEntry?.data?.party_type);
      setDataSourcePayment(
        paymentEntry?.data?.deductions?.length
          ? paymentEntry?.data?.deductions
          : [{}]
      );
      setDataSourceReference(
        paymentEntry?.data?.references?.length
          ? paymentEntry?.data?.references
          : [{}]
      );
      form.setFieldsValue({
        ...paymentEntry?.data,
        cheque_date: dayjs(paymentEntry?.data?.cheque_date),
        payment_type: paymentEntry?.data?.payment_type || 'Receive',
        posting_date: dayjs(paymentEntry?.data?.posting_date),
        // references: paymentEntry?.data?.references?.length
        //   ? paymentEntry?.data?.references : [{}],
        // deductions: paymentEntry?.data?.deductions?.length
        //   ? paymentEntry?.data?.deductions
        //   : [{}],
      });
      // if (paymentEntry?.data?.party_type === 'Customer') {
      //   onGetCustomer(paymentEntry?.data?.party);
      // }
    }
  }, [paymentEntry, edit]);
  useEffect(() => {
    if (salesOrderDetails?.message && salesOrder) {
      setDataStatus(salesOrderDetails?.message?.docstatus);
      onAddPaymentEntry(salesOrderDetails?.message?.party_type);
      setDataSourcePayment(
        salesOrderDetails?.message?.deductions?.length
          ? salesOrderDetails?.message?.deductions
          : [{}]
      );
      setDataSourceReference(
        salesOrderDetails?.message?.references?.length
          ? salesOrderDetails?.message?.references
          : [{}]
      );
      form.setFieldsValue({
        ...salesOrderDetails?.message,
        cheque_date: dayjs(salesOrderDetails?.message?.cheque_date),
        payment_type: salesOrderDetails?.message?.payment_type || 'Receive',
        posting_date: dayjs(salesOrderDetails?.message?.posting_date),
        // references: salesOrderDetails?.message?.references?.length
        //   ? salesOrderDetails?.message?.references : [{}],
        // deductions: salesOrderDetails?.message?.deductions?.length
        //   ? salesOrderDetails?.message?.deductions
        //   : [{}],
      });
      // if (salesOrderDetails?.message?.party_type === 'Customer') {
      //   onGetCustomer(salesOrderDetails?.message?.party);
      // }
    }
  }, [salesOrderDetails, salesOrder]);
  const mode_of_payment_selected = Form.useWatch('mode_of_payment', form);
  const select_reference_value = Form.useWatch('select_reference', form);
  const isStatusDisabledFiled = paymentEntry?.data
    ? paymentEntry?.data?.docstatus === 1 || paymentEntry?.data?.docstatus === 2
    : false;
  // console.log(paymentEntry?.data, 'paymentEntry?.data');
  const modeOfPayment_accounts = modeOfPayments?.message?.find(
    (s) => s?.value === mode_of_payment_selected
  )?.accounts;

  if (
    loadingSales ||
    loadingPayment ||
    loadingInvoice ||
    loadingEmployeeAdvance ||
    loadingSalesOrder
  ) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '95vh',
          width: '100%',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  // console.log(customerInvoice?.message[0].name, 'customerInvoice?.message[0].name');
  // console.log(customerInvoice?.message, 'customerInvoice?.message');
  const itemsMenu = [
    {
      key: '3',
      label: (
        <Button
          disabled={paymentEntry?.data?.docstatus === 0 ? false : true}
          type="text"
          size="small"
        >
          {t.submit}
        </Button>
      ),
      onClick: () => onSubmitPaymentEntry(id),
    },
    {
      key: '2',
      label: (
        <Button
          type="text"
          size="small"
          disabled={paymentEntry?.data?.docstatus === 1 ? false : true}
          loading={loadingAdd}
        >
          {t.CancelPayment}
        </Button>
      ),
      onClick: () => handleCancelSalesInvoice.mutate(id),
    },
    {
      key: '4',
      label: (
        <Button
          type="text"
          size="small"
          disabled={paymentEntry?.data?.docstatus === 1 ? false : true}
        >
          {t.GeneralLedger}
        </Button>
      ),
      onClick: () => {
        navigate(`/general-ledger-report-journal/${id}`);
      },
    },
    {
      key: '5',
      label: (
        <Button
          type="text"
          size="small"
          // disabled={paymentEntry?.data?.docstatus === 1 ? false : true}
        >
          {t.BankTransfer}
        </Button>
      ),
      onClick: () => {
        setOpenBankTransfer(true);
      },
    },
  ];
  return (
    <div className="payment-entry-add">
      {/* <Heading
        title={receipt ? t.receiptVoucher : t.paymentEntry}
        subTitle={
          receipt
            ? edit
              ? t.editReceiptVoucher
              : t.addReceiptVoucher
            : edit
            ? t.editPaymentEntry
            : t.AddPaymentEntry
        }
        path={receipt ? '/receipt-voucher' : '/receipt-voucher'}
        status={paymentEntry?.data?.status}
      /> */}
      <HeadingApp
        nameTab={t.SalesFinance}
        title={receipt ? t.receiptVoucher : t.paymentEntry}
        subTitle={
          receipt
            ? edit
              ? t.editReceiptVoucher
              : t.addReceiptVoucher
            : edit
            ? t.editPaymentEntry
            : t.AddPaymentEntry
        }
        icon={<FaMoneyBillWave />}
      />
      <Card style={{ borderRadius: '0px' }}>
        <Flex justify="space-between" style={{ marginBottom: '20px' }}>
          <h4>
            {receipt
              ? t.RECEIPTENTRYINFORMATION
              : t.ENTERPAYMENTENTRYINFORMATION}
          </h4>
          {edit && (
            <Dropdown
              menu={{ items: itemsMenu }}
              trigger={['click']}
              arrow
              className="btn-light"
              // onClick={() => setStatus(record)}
            >
              <Button size="small" type="text">
                {t.action}
                <DownOutlined />
              </Button>
            </Dropdown>
          )}
        </Flex>
        <Form
          layout="vertical"
          name="encounter-add"
          onFinish={onFinish}
          form={form}
          disabled={isStatusDisabledFiled}
          initialValues={{
            payment_type: 'Receive',
            references: [{}],
            deductions: [{}],
            posting_date: dayjs(),
          }}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} md={24} lg={18}>
              {/* <Divider orientation="left">
                {receipt ? t.ReceiptInformation : t.PaymentEntryInformation}
              </Divider> */}
              <Row gutter={[16, 0]}>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="payment_type"
                    label={t.PaymentType}
                    // label={t.name}
                    rules={[{ required: true }]}
                  >
                    <Select placeholder={t.PaymentType} disabled={receipt}>
                      <Select.Option value="Receive">{t.Receive}</Select.Option>
                      <Select.Option value="Pay">{t.Pay}</Select.Option>
                      <Select.Option value="Internal Transfer">
                        {t.InternalTransfer}
                      </Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="posting_date"
                    label={t.postingDate}
                    rules={[{ required: true }]}
                  >
                    <DatePicker
                      placeholder={t.postingDate}
                      format="YYYY-MM-DD"
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="mode_of_payment"
                    label={t.ModeofPayment}
                    // label={t.name}
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.ModeofPayment}
                      showSearch
                      optionFilterProp="children"
                      onChange={(value, data) => {
                        // console.log(data,"vdatadatadatadatadatadata");
                        onGetMopAccountMode(value);
                        if (watchPaymentType === 'Pay') {
                          form.setFieldsValue({
                            paid_from: data?.data?.accounts[0]?.default_account,
                          });
                        } else if (watchPaymentType === 'Receive') {
                          form.setFieldsValue({
                            paid_to: data?.data?.accounts[0]?.default_account,
                          });
                        } else if (invoice) {
                          form.setFieldsValue({
                            paid_from: data?.data?.accounts[0]?.default_account,
                          });
                        } else {
                          form.setFieldsValue({
                            paid_to: data?.data?.accounts[0]?.default_account,
                          });
                        }
                      }}
                      filterOption={false}
                      allowClear
                      onSearch={(value) => {
                        setSearchTxt(value);
                      }}
                      options={modeOfPayments?.message?.map((appointment) => ({
                        value: appointment?.value,
                        label: appointment?.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="party_type"
                    label={t.PartyType}
                    // label={t.name}
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.PartyType}
                      onChange={(value) => {
                        setLoadingParties(true);
                        onAddPaymentEntry(value);
                      }}
                      disabled={isStatusDisabledFiled || !!sales}
                      options={[
                        { value: 'Customer', label: t.Customer },
                        { value: 'Supplier', label: t.Supplier },
                        { value: 'Employee', label: t.Employee },
                        { value: 'Shareholder', label: t.Shareholder },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="party"
                    label={t.Party}
                    // label={t.name}
                    rules={[{ required: true }]}
                  >
                    <Select
                      loading={loadingParties}
                      placeholder={t.Party}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      disabled={isStatusDisabledFiled || !!sales}
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      onChange={(value, option) => {
                        setDataSourceReference([{}]);
                        if (customer === 'Customer') {
                          // onGetCustomer(value);
                          form.setFieldsValue({
                            paid_from: option?.data?.account_paid_to,
                          });
                        }
                      }}
                      //   onChange={onChangeAppointment}
                      options={partiesData?.message?.parties?.map((user) => ({
                        value: user?.name,
                        label: user?.name,
                        data: user,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}></Col>
                {/* <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item
                name="party_balance"
                label={t.PartyBalance}
                rules={[{ required: true }]}
              >
                <Input placeholder={t.PartyBalance} />
              </Form.Item>
            </Col> */}
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="paid_from"
                    label={t.AccountPaidFrom}
                    rules={[{ required: true }]}
                  >
                    {/* <Input
                      placeholder={t.AccountPaidFrom}
                      disabled={invoice ? false : true}
                    /> */}
                    <Select
                      placeholder={t.AccountPaidFrom}
                      showSearch
                      optionFilterProp="children"
                      filterOption={false}
                      allowClear
                      onSearch={(value) => {
                        setSearchTxtAccount(value);
                      }}
                      disabled={watchPaymentType === 'Receive'}
                      onClear={() => {
                        setSearchTxtAccount('');
                      }}
                      //   parties?.map((account) => ({
                      //   value: account?.name,
                      //   label: account?.account_name,
                      //   data: account,
                      // }))}
                      // initialValues={modeOfPayment_accounts?.length ? modeOfPayment_accounts[0]?.default_account : ''}
                      // options={
                      //   modeOfPayment_accounts?.length
                      //     ? modeOfPayment_accounts?.map((account) => ({
                      //         value: account?.default_account,
                      //         label: account?.default_account,
                      //         data: account,
                      //       }))
                      //     : []
                      // }
                      options={
                        // mopAccountMode?.message?.account
                        //   ? [
                        //       {
                        //         value: mopAccountMode?.message?.account,
                        //         label: mopAccountMode?.message?.account,
                        //         data: mopAccountMode?.message,
                        //       },
                        //     ]
                        //   :
                        modeOfPayment_accounts?.length
                          ? modeOfPayment_accounts?.map((account) => ({
                              value: account?.default_account,
                              label: account?.default_account,
                              data: account,
                            }))
                          : parties?.map((account) => ({
                              value: account?.value,
                              label: account?.value,
                              data: account,
                            }))
                      }
                    />
                    {/* <Select
                  placeholder={t.AccountPaidFrom}
                  onChange={(value, option) => {
                    console.log(option, 'option');
                    form.setFieldsValue({
                      paid_from_account_currency:
                        option?.data?.account_currency,
                    });
                  }}
                  // options={dataFilter?.map((account) => ({
                  //   value: account?.name,
                  //   label: account?.account_name,
                  //   data: account,
                  // }))}
                  options={parties?.map((account) => ({
                    value: account?.name,
                    label: account?.account_name,
                    data: account,
                  }))}
                /> */}
                    {/* <Input placeholder={t.AccountPaidFrom} /> */}
                  </Form.Item>
                </Col>
                {/* <Col xs={24} sm={12} md={12} lg={12}>
            {/* <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item
                name="paid_from_account_currency"
                label={t.AccountCurrencyFrom}
                initialValue={'SAR'}
              >
                <Input placeholder={t.AccountCurrencyFrom} disabled />
              </Form.Item>
            </Col> */}
                {/* </Col>  */}
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="paid_to"
                    label={t.AccountPaidTo}
                    // label={t.name}
                    rules={[{ required: true }]}
                    // initialValue={modeOfPayment_accounts?.length ? modeOfPayment_accounts[0]?.default_account : ''}
                  >
                    <Select
                      placeholder={t.AccountPaidTo}
                      showSearch
                      optionFilterProp="children"
                      filterOption={false}
                      allowClear
                      onSearch={(value) => {
                        setSearchTxtAccount(value);
                      }}
                      // disabled={invoice}
                      disabled={watchPaymentType === 'Pay'}
                      onClear={() => {
                        setSearchTxtAccount('');
                      }}
                      //   parties?.map((account) => ({
                      //   value: account?.name,
                      //   label: account?.account_name,
                      //   data: account,
                      // }))}
                      // initialValues={modeOfPayment_accounts?.length ? modeOfPayment_accounts[0]?.default_account : ''}
                      // options={
                      //   modeOfPayment_accounts?.length
                      //     ? modeOfPayment_accounts?.map((account) => ({
                      //         value: account?.default_account,
                      //         label: account?.default_account,
                      //         data: account,
                      //       }))
                      //     : []
                      // }
                      options={
                        // mopAccountMode?.message?.account
                        //   ? [
                        //       {
                        //         value: mopAccountMode?.message?.account,
                        //         label: mopAccountMode?.message?.account,
                        //         data: mopAccountMode?.message,
                        //       },
                        //     ]
                        //   :
                        modeOfPayment_accounts?.length
                          ? modeOfPayment_accounts?.map((account) => ({
                              value: account?.default_account,
                              label: account?.default_account,
                              data: account,
                            }))
                          : parties?.map((account) => ({
                              value: account?.value,
                              label: account?.value,
                              data: account,
                            }))
                      }
                    />
                    {/* <Input placeholder={t.AccountPaidTo} /> */}
                  </Form.Item>
                </Col>
                {/* <Col xs={24} sm={12} md={12} lg={12}>
            {/* <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item
                name="paid_to_account_currency"
                label={t.AccountCurrencyTo}
                rules={[{ required: true }]}
              >
                <Input placeholder={t.AccountCurrencyTo} />
              </Form.Item>
            </Col> */}
                {/* </Col>  */}
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="paid_amount"
                    label={t.PaidAmount}
                    rules={[{ required: true }]}
                  >
                    <Input placeholder={t.PaidAmount} type="number" />
                  </Form.Item>
                </Col>
                {/* <Col xs={24} sm={12} md={12} lg={12}>
            {/* <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item
                name="reference_no"
                label={t.ChequeReferenceNo}
                rules={[{ required: true }]}
              >
                <Input placeholder={t.ChequeReferenceNo} />
              </Form.Item>
            </Col> */}
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="cheque_date"
                    label={t.ChequeReferenceDate}
                    // rules={[{ required: true }]}
                  >
                    <DatePicker
                      placeholder={t.ChequeReferenceDate}
                      format="YYYY-MM-DD"
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>

                <Divider orientation="left"> {t.PaymentReferences} </Divider>
                <Col
                  span={24}
                  className="items"
                  style={{ marginBottom: '20px' }}
                >
                  {/* {customerInvoice?.message ? (
                <Form.Item
                  name="select_reference"
                  label={t.select_invoice}
                  // rules={[{ required: true }]}
                  style={{ minWidth: '200px' }}
                >
                  <Select
                    placeholder={t.select_invoice}
                    mode="multiple"
                    // style={{ width: '200px' }}
                    options={customerInvoice?.message?.map((account) => ({
                      value: account?.name,
                      label: account?.name,
                    }))}
                    popupMatchSelectWidth={false}
                  />
                </Form.Item>
              ) : null}*/}
                  {/* <Form.List name="references" style={{ width: '100%' }}>
                {(fields, { add, remove }) => (
                  <>
                    {fields?.map(({ key, name, ...restField }) => (
                      <Space
                        key={key}
                        style={{
                          display: 'flex',
                          //   marginBottom: 8,
                          //   justifyContent: 'space-between',
                          alignItems: 'center',
                          width: '100%',
                        }}
                        // align="baseline"
                      >
                        <Form.Item
                          name={[name, 'reference_doctype']}
                          label={t.type}
                          style={{ width: '100%', marginBottom: '0px' }}
                          // rules={[{ required: true }]}
                          {...restField}
                        >
                          <Select
                            placeholder={t.type}
                            style={{ width: '100%' }}
                            popupMatchSelectWidth={false}
                            onChange={(value) => {
                              // console.log(value, 'value');
                              setValueReferenceType(value);
                              // onGetPaymentReferences(value);
                            }}
                            disabled={isStatusDisabledFiled || !!sales}
                            options={[
                              {
                                value: 'Sales Invoice',
                                label: t.salesInvoice,
                              },
                              {
                                value: 'Sales Order',
                                label: t.SalesOrder,
                              },
                              {
                                value: 'Duning',
                                label: t.Duning,
                              },
                              {
                                value: 'Journal Entry',
                                label: t.JournalEntry,
                              },
                            ]}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[name, 'reference_name']}
                          style={{ width: '100%', marginBottom: '0px' }}
                          {...restField}
                          label={t.Name}
                        >
                          <Select
                            placeholder={t.Name}
                            style={{ width: '100%' }}
                            popupMatchSelectWidth={false}
                            loading={loadingPaymentReference}
                            onChange={(value,option) => {
                              form.setFieldsValue({
                                references: [{
                                  reference_name:valueReferenceType,
                                  total_amount: option?.option?.grand_total,
                                  outstanding_amount: option?.option?.outstanding_amount,
                                }],
                              })
                            }}
                            options={paymentReferencesName?.message?.references?.map((account) => ({
                              value: account?.name,
                              label: account?.name,
                              option: account,
                            }))}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[name, 'total_amount']}
                          style={{ width: '100%', marginBottom: '0px' }}
                          {...restField}
                          label={t.GrandTotal}
                        >
                          <Input
                            placeholder={t.GrandTotal}
                            style={{ width: '100%' }}
                            type="number"
                            disabled
                          />
                        </Form.Item>
                        <Form.Item
                          name={[name, 'outstanding_amount']}
                          style={{ width: '100%', marginBottom: '0px' }}
                          {...restField}
                          label={t.Outstanding}
                        >
                          <Input
                            placeholder={t.Outstanding}
                            style={{ width: '100%' }}
                            type="number"
                            disabled
                          />
                        </Form.Item>
                        <Form.Item
                          name={[name, 'allocated_amount']}
                          style={{ width: '100%', marginBottom: '0px' }}
                          {...restField}
                          label={t.Allocated}
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (
                                  getFieldValue([
                                    'references',
                                    name,
                                    'outstanding_amount',
                                  ]) < value
                                ) {
                                  return Promise.reject(
                                    new Error(
                                      t.allocatedAmountGreaterThanOutstanding
                                    )
                                  );
                                }
                                return Promise.resolve();
                              },
                            }),
                          ]}
                        >
                          <Input
                            placeholder={t.Allocated}
                            style={{ width: '100%' }}
                            type="number"
                            min={0}
                            max={form.getFieldValue([
                              'references',
                              name,
                              'outstanding_amount',
                            ])}
                          />
                        </Form.Item>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontSize: '15px',
                            margin: '0 10px',
                          }}
                        >
                          {fields.length > 1 && (
                            <Button
                              type="text"
                              onClick={() => remove(name)}
                              danger
                              icon={<MdDelete color="red" />}
                            />
                          )}
                          <Button
                            type="text"
                            onClick={() => add()}
                            icon={<PlusOutlined color="#1890ff" />}
                          />
                        </div>
                      </Space>
                    ))}
                  </>
                )}
              </Form.List> */}
                  <PaymentReferencesList
                    isStatusDisabledFiled={isStatusDisabledFiled}
                    sales={sales}
                    setValueReferenceType={setValueReferenceType}
                    t={t}
                    watchPartyId={watchPartyId}
                    //  paymentReferencesName={paymentReferencesName}
                    setDataSourceReference={setDataSourceReference}
                    dataSourceReference={dataSourceReference}
                  />
                  {/* <Form.List name="references" style={{ width: '100%' }}>
  {(fields, { add, remove }) => (
    <>
      {fields?.map(({ key, name, ...restField }) => (
        <Space
          key={key}
          style={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <Form.Item
            name={[name, 'reference_doctype']}
            label={t.type}
            style={{ width: '100%', marginBottom: '0px' }}
            rules={[{ required: true }]}
            {...restField}
          >
            <Select
              placeholder={t.type}
              style={{ width: '100%' }}
              onChange={(value) => {
                setValueReferenceType(value);
                onGetPaymentReferences(value);
              }}
              disabled={!!sales}
              options={[
                { value: 'Sales Invoice', label: t.salesInvoice },
                { value: 'Sales Order', label: t.SalesOrder },
                { value: 'Duning', label: t.Duning },
                { value: 'Journal Entry', label: t.JournalEntry },
              ]}
            />
          </Form.Item>
          <Form.Item
            name={[name, 'reference_name']}
            style={{ width: '100%', marginBottom: '0px' }}
            {...restField}
            label={t.Name}
          >
            <Select
              placeholder={t.Name}
              options={customerInvoice?.message?.map((account) => ({
                value: account?.name,
                label: account?.name,
              }))}
              onChange={(value) => {
                const filterName = customerInvoice?.message.find(
                  (invoice) => value === invoice.name
                );
                const currentValues = form.getFieldValue('references') || [];
                const newValues = currentValues.map((item, index) =>
                  index === name
                    ? {
                        ...item,
                        reference_doctype: sales
                          ? 'Sales Invoice'
                          : 'Sales Invoice',
                        total_amount: filterName?.total,
                        outstanding_amount: filterName?.outstanding_amount,
                        reference_name: filterName?.name,
                      }
                    : item
                );
                form.setFieldsValue({ references: newValues });
              }}
              popupMatchSelectWidth={false}
            />
          </Form.Item>
          <Form.Item
            name={[name, 'total_amount']}
            style={{ width: '100%', marginBottom: '0px' }}
            {...restField}
            label={t.GrandTotal}
          >
            <Input
              placeholder={t.GrandTotal}
              style={{ width: '100%' }}
              type="number"
              disabled
            />
          </Form.Item>
          <Form.Item
            name={[name, 'outstanding_amount']}
            style={{ width: '100%', marginBottom: '0px' }}
            {...restField}
            label={t.Outstanding}
          >
            <Input
              placeholder={t.Outstanding}
              style={{ width: '100%' }}
              type="number"
              disabled
            />
          </Form.Item>
          <Form.Item
            name={[name, 'allocated_amount']}
            style={{ width: '100%', marginBottom: '0px' }}
            {...restField}
            label={t.Allocated}
          >
            <Input
              placeholder={t.Allocated}
              style={{ width: '100%' }}
              type="number"
              min={0}
              max={form.getFieldValue(['references', name, 'outstanding_amount'])}
            />
          </Form.Item>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontSize: '15px',
              margin: '0 10px',
            }}
          >
            {fields.length > 1 && (
              <Button
                type="text"
                onClick={() => remove(name)}
                danger
                icon={<MdDelete color="red" />}
              />
            )}
            <Button
              type="text"
              onClick={() => add()}
              icon={<PlusOutlined color="#1890ff" />}
            />
          </div>
        </Space>
      ))}
    </>
  )}
                </Form.List> */}
                </Col>
                <Divider orientation="left"> {t.deductions} </Divider>
                <Col
                  span={24}
                  className="items"
                  style={{ marginBottom: '20px' }}
                >
                  {/* <Form.List name="deductions" style={{ width: '100%' }}>
                {(fields, { add, remove }) => (
                  <>
                    {fields?.map(({ key, name, ...restField }) => (
                      <Space
                        key={key}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        <Form.Item
                          name={[name, 'account']}
                          label={t.Account}
                          style={{ width: '100%', marginBottom: '0px' }}
                          // rules={[{ required: true }]}
                          {...restField}
                        >
                          <Select
                            placeholder={t.Account}
                            style={{ width: '100%' }}
                            options={parties?.map((item) => ({
                              value: item?.name,
                              label: item?.account_name,
                            }))}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[name, 'cost_center']}
                          style={{ width: '100%', marginBottom: '0px' }}
                          {...restField}
                          label={t.costCenter}
                        >
                          <Select
                            placeholder={t.costCenter}
                            style={{ width: '100%' }}
                            options={costCenters?.data?.map((item) => ({
                              value: item?.name,
                              label: item?.cost_center_name,
                            }))}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[name, 'amount']}
                          style={{ width: '100%', marginBottom: '0px' }}
                          {...restField}
                          label={t.amount}
                        >
                          <Input
                            placeholder={t.amount}
                            style={{ width: '100%' }}
                            type="number"
                            min={0}
                          />
                        </Form.Item>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontSize: '15px',
                            margin: '0 10px',
                          }}
                        >
                          {fields.length > 1 && (
                            <Button
                              type="text"
                              onClick={() => remove(name)}
                              danger
                              icon={<MdDelete color="red" />}
                            />
                          )}
                          <Button
                            type="text"
                            onClick={() => add()}
                            icon={<PlusOutlined color="#1890ff" />}
                          />
                        </div>
                    </Space>
                    ))}
                  </>
                )}
              </Form.List> */}
                  <DeductionsListPayment
                    setDataSourcePayment={setDataSourcePayment}
                    dataSourcePayment={dataSourcePayment}
                    t={t}
                  />
                </Col>
                <Divider />
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="unallocated_amount"
                    label={t.unallocated_amount}
                  >
                    <Input
                      placeholder={t.unallocated_amount}
                      type="number"
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="total_allocated_amount"
                    label={t.total_allocated_amount}
                  >
                    <Input
                      placeholder={t.total_allocated_amount}
                      type="number"
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="difference_amount"
                    label={t.differenceAmount}
                  >
                    <Input
                      placeholder={t.differenceAmount}
                      type="number"
                      disabled
                    />
                  </Form.Item>
                </Col>
              </Row>
              <div className="form-btns">
                <Button type="primary" ghost onClick={() => navigate(-1)}>
                  {t.Cancel}
                </Button>
                <Button
                  type="primary"
                  loading={loadingAdd}
                  // block
                  onClick={() => {
                    if (submitButton) {
                      setLoadingAdd(true);
                      onSubmitPaymentEntry(selectName);
                    } else {
                      form.submit();
                    }
                  }}
                >
                  {submitButton
                    ? t.submit + ' ' + t.payment
                    : edit
                    ? t.edit + ' ' + t.payment
                    : t.Save + ' ' + t.payment}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Card>
      <ModalAddBankTransfer
        t={t}
        open={openBankTransfer}
        setOpen={setOpenBankTransfer}
        editId={id}
      />
    </div>
  );
};

export default PaymentEntryAdd;
